import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestTypeEnum, type ToastProps } from '../domain/toast';

// ToastProps are based on ApiResponseStatus attributes + isDisplayed
const initialState: ToastProps = {
    code: -1, 
    isDisplayed: false,
    isLoadingCounter: 0,
    messageKey: '',
    requestType: RequestTypeEnum.unknown,
    text: ''
};

const toastSlice = createSlice({
    initialState,
    name: 'toast',
    reducers: {
        clearToast: (state) => {
            state.isDisplayed = false;

            // Avoid using initialState here to avoid displaying wrong severity and text while toast is closing
        },
        toggleToast: (state, action: PayloadAction< ToastProps>) => {
            if (action.payload?.code !== 200) {
                state.code = action.payload?.code;
                state.requestType = action.payload?.requestType ?? RequestTypeEnum.unknown;
                state.severity = 'error';
                state.text = action.payload.text;
                state.messageKey = action.payload.messageKey;
                
                if (action.payload?.text == 'Network Error' && action.payload.requestType?.startsWith('get')) {
                    state.severity = 'warning';
                    state.requestType = RequestTypeEnum.getNetwork;
                }
                if (action.payload?.text == 'Network Error' && action.payload.requestType?.startsWith('create')) {
                    state.requestType = RequestTypeEnum.createNetwork;
                }
                if (action.payload?.text == 'Network Error' && action.payload.requestType?.startsWith('update')) {
                    state.requestType = RequestTypeEnum.updateNetwork;
                }
                if (action.payload?.text == 'Network Error' && action.payload.requestType?.startsWith('add')) {
                    state.requestType = RequestTypeEnum.addNetwork;
                }
                state.isDisplayed = true;

            } else if (action.payload?.code == 200) {
                state.severity = 'success';
                state.code = action.payload?.code;

                state.requestType = action.payload?.requestType ?? RequestTypeEnum.unknown;
                state.isDisplayed = true;

                /*
                 * We don't update requestType when toast is not displayed to avoid text conflicts
                 * if (action.payload?.requestType == 'updateVehicle') {
                 */
                   
                /*
                 * } 
                 * if (action.payload?.requestType == 'createFleet') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 * if (action.payload?.requestType == 'createVehicle') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 * if (action.payload?.requestType == 'removeVehicle') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 * if (action.payload?.requestType == 'deleteVehicle') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 * if (action.payload?.requestType == 'updateGroup') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * } 
                 * if (action.payload?.requestType == 'createMember') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 * if (action.payload?.requestType == 'createGroup') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 * if (action.payload?.requestType == 'deleteGroup') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * } 
                 */
            } else if (action.payload?.code == 204) {
                state.severity = 'info';
                state.code = action.payload?.code;
                state.requestType = action.payload?.requestType ?? RequestTypeEnum.unknown;
                state.isDisplayed = true;

                /*
                 * We don't update requestType when toast is not displayed to avoid text conflicts
                 * if (action.payload?.requestType == 'deleteGroup') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * } 
                 * if (action.payload?.requestType == 'deleteFleet') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 * if (action.payload?.requestType == 'removeVehicle') {
                 *     state.requestType = action.payload?.requestType ?? '';
                 *     state.isDisplayed = true;
                 * }
                 */
            }
        },
        setLoader(state) {
            state.isLoadingCounter++;
        },
        unsetLoader(state) {
            if (state.isLoadingCounter > 0) {
                state.isLoadingCounter--;
            }
        }
    },
});

export const { toggleToast, clearToast, setLoader, unsetLoader } = toastSlice.actions;
export default toastSlice.reducer;